import { createSelector } from "@reduxjs/toolkit";
import { isInfant } from "../selectors/passengers.js";
export const getSubsidizedFares = (state) => state.flightDetails.flight?.subsidizedFares;
export const getFlightPointOfSale = (state) => state.flightDetails.flight?.pointOfSale;
export const getHasFlight = (state) => !!state.flightDetails.flight;
export const getFlight = (state) => state.flightDetails.flight;
export const getFlightError = (state) => state?.flightDetails?.error;
export const getFlightToken = (state) => state.flightDetails.flight?.token;
export const getIsMultiTraveller = (state) => (state.flightDetails.flight?.travellers?.length || 0) > 1;
export const getBrandedFareOffers = (state) => state.flightDetails.flight?.brandedFareOffers;
export const getComparisonTable = (state) => state.flightDetails.flight?.brandedFareComparisonTable;
export const getAncillaries = (state) => state.flightDetails.flight?.ancillaries;
export const getFlightDetailsFetchStatus = (state) => state.flightDetails.fetchStatus;
export const getFlightDetailsSegments = (state) => state.flightDetails.flight?.segments;
export const getCanSkipExtrasPage = (state) => state.flightDetails.flight?.displayOptions?.skipExtrasPage;
export const getFareRules = (state) => state.flightDetails.flight?.fareRules;
export const getBrandedFareInfo = (state) => state.flightDetails.flight?.brandedFareInfo;
export const getArrivalPlace = createSelector((state) => state.flightDetails.flight?.segments[0]?.arrivalAirport, (arrivalAirport) => {
    return { code: arrivalAirport?.code, type: arrivalAirport?.type };
});
export const getTripType = (state) => state.flightDetails.flight?.tripType;
export const getArrivalCountry = (state) => state.flightDetails.flight?.segments[0]?.arrivalAirport.country;
export const getLastDepartureDate = (state) => getTripType(state) === "ROUNDTRIP"
    ? state.flightDetails.flight?.segments[state.flightDetails.flight?.segments.length - 1].arrivalTime?.split("T")[0]
    : state.flightDetails.flight?.segments[0].arrivalTime?.split("T")[0];
export const getTravellers = (state) => getFlight(state)?.travellers ?? [];
export const getPayingTravellersCount = createSelector(getTravellers, (travellers) => {
    const totalTravellersCount = travellers.length;
    const infantsCount = travellers.filter((t) => isInfant(t)).length;
    return Math.max(1, totalTravellersCount - infantsCount);
});
export const getFlightDetailsSlice = (state) => state.flightDetails;
